<div class="chat-wrapper">

    <!-- Floating Button -->

    <button class="chat-toggle" *ngIf="!visible" (click)="visible = true">
        <i class="pi pi-comments"></i>
    </button>


    <!-- Chat Window -->

    <div class="chat-window" *ngIf="visible">

        <!-- Header -->

        <div class="chat-header">

            <div class="header-left">
                <div class="bot-avatar">
                    <img src="assets/images/iimalogo--removebg-preview[1] (1).png" alt="bot">
                </div>
                <div class="title">Chatbot</div>
            </div>

            <div class="header-actions">
                <button (click)="minimizeChatbot()">
                    <i class="pi pi-minus"></i>
                </button>

                <button (click)="closeChatbot()">
                    <i class="pi pi-times"></i>
                </button>
            </div>

        </div>


        <!-- Messages -->

        <div class="chat-body" #chatContainer>

            <ng-container *ngFor="let msg of chatMessages">

                <!-- Hide suggestion messages in chat body -->

                <div *ngIf="!msg.isSuggestion" [ngClass]="msg.fromUser ? 'user-row' : 'bot-row'">

                    <div class="message">
                        {{msg.text}}
                    </div>

                </div>

            </ng-container>

        </div>


        <!-- Suggestions -->

        <div class="suggestions" *ngIf="hasSuggestions">

            <ng-container *ngFor="let msg of chatMessages">

                <button *ngIf="msg.isSuggestion" (click)="selectSuggestion(msg.text)">
                    {{msg.text}}
                </button>

            </ng-container>

        </div>


        <!-- Input -->

        <div class="chat-footer">

            <input type="text" [(ngModel)]="userMessage" placeholder="Type message..."
                (keydown.enter)="sendMessage()" />

            <button (click)="sendMessage()">
                <i class="pi pi-send"></i>
            </button>

        </div>

    </div>

</div>